import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { ShieldX, ArrowLeft } from 'lucide-react';
import { Button } from '../components/ui/Button';

export function UnauthorizedPage() {
  const navigate = useNavigate();
  const { t } = useTranslation();

  return (
    <div className="min-h-screen flex items-center justify-center bg-[var(--amy-bg)] dark:bg-[var(--amy-bg)] px-4">
      <div className="text-center">
        <div className="inline-flex items-center justify-center w-20 h-20 rounded-full bg-red-100 dark:bg-red-900/20 mb-6">
          <ShieldX className="w-10 h-10 text-red-600 dark:text-red-400" />
        </div>
        <h1 className="text-2xl font-bold text-gray-900 dark:text-[var(--amy-text)] mb-2">
          {t('errors.unauthorized_title')}
        </h1>
        <p className="text-gray-600 dark:text-[var(--amy-muted)] mb-8 max-w-sm mx-auto">
          {t('errors.unauthorized_message')}
        </p>
        <Button
          variant="primary"
          leftIcon={<ArrowLeft className="w-4 h-4" />}
          onClick={() => navigate('/')}
        >
          {t('errors.back_to_dashboard')}
        </Button>
      </div>
    </div>
  );
}
